import styled from "styled-components";

export const FormData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1rem;
  position: relative;
`

export const InputLabel = styled.label`
  font-weight: 700;
  color: #000;
`

export const InputData = styled.input`
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 40px;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const SelectData = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 1rem;
  border-radius: 2rem;
`